import { Play, Pause, ChevronLeft, ChevronRight } from "lucide-react";
import { format } from "date-fns";
import { useI18n } from "@/lib/i18n";
import { Slider } from "@/components/ui/slider";

const Legend = ({ param }) => {
  const { t } = useI18n();
  const s = param.stops, min = s[0][0], max = s[s.length - 1][0];
  const grad = s.map(([v, c]) => `${c} ${((v - min) / (max - min)) * 100}%`).join(",");
  return (
    <div data-testid="map-legend" className="w-full sm:w-64">
      <div className="mb-1 flex justify-between font-mono text-[10px] uppercase text-slate-400">
        <span>{t(param.label)}</span><span>{t(param.unit)}</span>
      </div>
      <div className="h-2.5 rounded-full" style={{ background: `linear-gradient(90deg,${grad})` }} />
      <div className="mt-1 flex justify-between font-mono text-[10px] text-slate-500">
        {s.map(([v]) => <span key={v}>{v}</span>)}
      </div>
    </div>
  );
};

export const TimeBar = ({ times, t, setT, playing, setPlaying, param, nowIdx }) => {
  const { t: tr_, locale } = useI18n();
  const label = times.length ? format(new Date(times[t]), "d MMMM EEEE · HH:mm", { locale }) : tr_("Yükleniyor…");
  return (
    <div data-testid="time-bar" className="glass absolute bottom-3 left-3 right-3 z-[1000] flex flex-col gap-3 rounded-2xl px-4 py-3 sm:flex-row sm:items-center sm:gap-6">
      <div className="flex items-center gap-2">
        <button data-testid="time-prev-btn" onClick={() => setT(Math.max(0, t - 1))} className="rounded-full p-1.5 text-slate-300 hover:bg-white/10"><ChevronLeft size={18} /></button>
        <button data-testid="map-play-pause-btn" onClick={() => setPlaying(!playing)}
          className="flex h-10 w-10 items-center justify-center rounded-full bg-sky-400 text-slate-950 transition-transform hover:scale-105">
          {playing ? <Pause size={18} /> : <Play size={18} className="ml-0.5" />}
        </button>
        <button data-testid="time-next-btn" onClick={() => setT(Math.min(times.length - 1, t + 1))} className="rounded-full p-1.5 text-slate-300 hover:bg-white/10"><ChevronRight size={18} /></button>
        <div className="ml-2 min-w-[190px]">
          <div data-testid="map-time-label" className="font-heading text-lg font-bold capitalize text-white">{label}</div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500">
            {t === nowIdx ? <span className="text-emerald-400">● {tr_("Şimdi")}</span> : `${t - nowIdx > 0 ? "+" : ""}${t - nowIdx} ${tr_("saat")}`} · {tr_("Türkiye saati")}
          </div>
        </div>
      </div>
      <div className="flex-1 px-1">
        <Slider data-testid="map-time-slider" value={[t]} min={0} max={Math.max(0, times.length - 1)} step={1} onValueChange={([v]) => setT(v)} />
        <div className="mt-1.5 flex justify-between font-mono text-[10px] text-slate-500">
          {times.filter((x) => x.endsWith("T00:00")).map((x) => <span key={x}>{format(new Date(x), "d MMM EEE", { locale })}</span>)}
        </div>
      </div>
      <Legend param={param} />
    </div>
  );
};
